var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.66669H23.6667C24.3739 5.66669 25.0522 5.94764 25.5523 6.44774C26.0524 6.94783 26.3333 7.62611 26.3333 8.33335V27C26.3333 27.7073 26.0524 28.3855 25.5523 28.8856C25.0522 29.3857 24.3739 29.6667 23.6667 29.6667H7.66667C6.95942 29.6667 6.28115 29.3857 5.78105 28.8856C5.28095 28.3855 5 27.7073 5 27V8.33335C5 7.62611 5.28095 6.94783 5.78105 6.44774C6.28115 5.94764 6.95942 5.66669 7.66667 5.66669H10.3333",
    stroke: "current",
    strokeWidth: 1.99932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6673 3H11.6673C10.9309 3 10.334 3.59695 10.334 4.33333V7C10.334 7.73638 10.9309 8.33333 11.6673 8.33333H19.6673C20.4037 8.33333 21.0007 7.73638 21.0007 7V4.33333C21.0007 3.59695 20.4037 3 19.6673 3Z",
    stroke: "current",
    strokeWidth: 1.99932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/result.51e9ebaa219e781e798750796d3356a8.svg";
export { ForwardRef as ReactComponent };